module.exports = __webpack_public_path__ + "img/10.f0be636e.svg";